var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.719959 17.4199L5.83865 12.3012C4.84715 11.0765 4.25017 9.5202 4.25017 7.82521C4.25017 3.89671 7.44665 0.700195 11.3751 0.700195C15.3036 0.700195 18.5 3.89667 18.5 7.82517C18.5 11.7537 15.3035 14.9502 11.3751 14.9502C9.6801 14.9502 8.12385 14.3532 6.89913 13.3617L1.78044 18.4804C1.63419 18.6267 1.4422 18.7002 1.25018 18.7002C1.05816 18.7002 0.866171 18.6267 0.719923 18.4804C0.426689 18.1872 0.426688 17.7132 0.719959 17.4199V17.4199ZM11.3739 13.4502C14.4759 13.4502 16.9988 10.9272 16.9988 7.82516C16.9988 4.72315 14.4759 2.20016 11.3739 2.20016C8.27191 2.20016 5.74895 4.72315 5.74895 7.82516C5.74895 10.9272 8.27195 13.4502 11.3739 13.4502V13.4502Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1a0903e017a38020b7f44b5f0b7fc50c.svg";
export { ForwardRef as ReactComponent };